import { ReactNode } from 'react';
import { LucideIcon } from 'lucide-react';

interface SectionHeaderProps {
  icon: LucideIcon;
  title: string;
  action?: ReactNode;
  className?: string;
}

/**
 * Reusable section header component with icon and optional action
 * Provides consistent styling across detail views
 */
export function SectionHeader({ icon: Icon, title, action, className = '' }: SectionHeaderProps) {
  return (
    <div className={`flex items-center justify-between mb-4 ${className}`}>
      <h2 className="text-lg font-semibold text-foreground flex items-center gap-2">
        <Icon className="h-5 w-5 text-primary" />
        {title}
      </h2>
      {action && <div>{action}</div>}
    </div>
  );
}
